export enum AreaServiceType {
  Planning = "Planning",
  Pricing = "Planning"
}
